import React from 'react';
import {
  Button,
  Form,
  Panel,
} from 'react-bootstrap';
import ClioDocumentCategorySelector from "../../../Integrations/connections/ClioDocumentCategorySelector";
import PropTypes from 'prop-types';
import ClioMatter from "./ClioMatter";

export default class ClioCaseFolderSettingsForm extends React.Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    settings: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  state = {
    // form values:
    client_id: null,
    matter_id: null,
    document_category_id: null,

    // form state:
    isPristine: true,
    isSubmitting: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevSettings = prevProps.settings;

    // when we receive settings prop, copy values to state
    ['client_id', 'matter_id', 'document_category_id'].forEach(
      setting => {
        if (prevSettings[setting] !== this.props.settings[setting])
          this.state[setting] = this.props.settings[setting];
      }
    );
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({ isSubmitting: true });

    // Call onSave handler with the values
    const {client_id, matter_id, document_category_id} = this.state;

    // TODO - all three fields are required.  Should provide some kind of feeback if anything
    // is missing?

    this.props.onSave({
      client_id,
      matter_id,
      document_category_id
    });

    // reset form state
    this.setState({
      isPristine: true,
      isSubmitting: false,
    });
  }

  render() {
    const {connectionId, settings} = this.props;
    const {isSubmitting, isPristine} = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        {false && <pre>{JSON.stringify(this.state)}</pre>}
        <ClioMatter
          connectionId={connectionId}
          matterId={settings.matter_id}
          onMatterSelect={matter =>
            this.setState({
              client_id: matter.client.id,
              matter_id: matter.id,
              isPristine: false,
            })
          }
        />

        <Panel>
          <Panel.Heading>Document Category</Panel.Heading>
          <Panel.Body>
            <ClioDocumentCategorySelector
              connectionId={connectionId}
              clearable={false}
              required={true}
              value={this.state.document_category_id}
              onChange={documentCategoryId =>
                this.setState({
                  document_category_id: documentCategoryId,
                  isPristine: false,
                })
              }
            />
          </Panel.Body>
        </Panel>
        <Button type="submit" bsStyle="primary" disabled={isSubmitting || isPristine}>Save</Button>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioCaseFolderSettingsForm.jsx